import { useEffect, useState } from "react";

export default function LoadingScreen() {
  const [hidden, setHidden] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setHidden(true), 1300);
    return () => clearTimeout(t);
  }, []);
  return (
    <div
      className={`fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#FAFAF7] transition-opacity duration-700 ${hidden ? "opacity-0 pointer-events-none" : "opacity-100"}`}
      data-testid="loading-screen"
    >
      <img src="/logo-trim.png" alt="SOL Kids" className="h-32 md:h-36 w-auto" draggable="false" />
      <div className="flex gap-1.5 mt-6">
        <span className="w-1.5 h-1.5 rounded-full bg-[#DD2E20] loader-dot" style={{ animationDelay: "0s" }} />
        <span className="w-1.5 h-1.5 rounded-full bg-[#F4C734] loader-dot" style={{ animationDelay: "0.16s" }} />
        <span className="w-1.5 h-1.5 rounded-full bg-[#8BC547] loader-dot" style={{ animationDelay: "0.32s" }} />
      </div>
    </div>
  );
}
